import $ from 'jquery';
import getParam from '../utils/getParam';

$(() => {
  if($('#registration-window').length === 0) return;

  if (getParam('rdz-free-subs') === 'true') {
    $.fancybox.open({
      src: '#registration-window',
      closeExisting: true,
      smallBtn: false,
      toolbar: false,
      touch: false,
    });
  }
});
